function normalizedName(value: string | null | undefined): string {
  return String(value ?? '')
    .normalize('NFC')
    .trim()
    .replace(/\s+/g, ' ')
    .toLocaleLowerCase('vi-VN');
}

export function visibleProductDetailName(
  productName: string | null | undefined,
  detailName: string | null | undefined
): string {
  const detail = String(detailName ?? '').trim();
  if (!detail || normalizedName(productName) === normalizedName(detail)) return '';
  return detail;
}

export function productSecondaryText(
  productName: string | null | undefined,
  detailName: string | null | undefined,
  ...parts: Array<string | null | undefined | false>
): string {
  return [visibleProductDetailName(productName, detailName), ...parts]
    .filter((part): part is string => typeof part === 'string' && part.trim().length > 0)
    .join(' · ');
}
